import React from 'react'

import { TableRow } from '@mui/material'

import TableHeaderCell from 'components/table/TableHeaderCell'
import type { ColumnConfig } from 'components/table/types'

type TableHeaderProps = {
  config: ColumnConfig[]
  hasExpandableItems: boolean
  sortBy?: string
  sortOrder?: string
  onSort?: (...args: any[]) => any
}

const TableHeader = ({ config, hasExpandableItems, sortOrder, sortBy, onSort }: TableHeaderProps) => {
  return (
    <TableRow>
      {hasExpandableItems && <TableHeaderCell cell={{ headerStyle: { width: 40 } }} />}
      {config.map((cell, index: number) => (
        <TableHeaderCell cell={cell} key={index} onSort={onSort} sortBy={sortBy} sortOrder={sortOrder} />
      ))}
    </TableRow>
  )
}

export default TableHeader
